/* eslint-disable no-use-before-define */
import React from 'react'
import { Fields, arrayToggle, arrayFrom } from '../../../twd/twd'
import useScatterGraph, { RATINGS } from '../use-scatter-graph';
import CircleLabel from './circle-label'


export default ({id}) => {
    const { colors, RATINGS, ratings, setRatings } = useScatterGraph()

    return <React.Fragment>
    <Fields.Search
        id={id}
        dataName="municipals-scatter-graph-credit-rating"
        placeholder={getPlaceholder(ratings, 'Select')}
        type="select"
        onSelect={(a) => {
            let arr = arrayToggle(ratings, a.value)
            setRatings([...arr])
        }}
    >
    {() =>
        <React.Fragment><div>{
        RATINGS
        .map((a,i) => {
            return {
                value:a.value,
                label:a.label,
                color: colors[5+i],
                selected: ratings.indexOf(a.value)>=0
            }
        })
        .map((a,i) => (
            <Fields.SearchOption
                dataName="municipals-scatter-graph-rating"
                item={a} key={i}>
            <Fields.CheckboxLabel
                dataName="municipals-scatter-graph-rating-option"
                checked={a.selected}
                label={<CircleLabel color={a.color} label={a.label} />} />
            </Fields.SearchOption>)
        )
        }</div></React.Fragment>
    }
    </Fields.Search>
    </React.Fragment>
}

const getPlaceholder = (arr, emptyText) => {
    arr = arrayFrom(arr)
    let n = arr.length
    if (n===0) return emptyText

    let a = RATINGS.filter(a => a.value===arr[0])[0]
    if (!a) return emptyText

    return a.label + (n > 1 ? ` + ${n-1} selected` : '')
}